import React, { useContext, useEffect, useState } from "react";
import { multiStepContext } from "./ContextApiComponent";
import { Form, Row, Col } from "react-bootstrap";
import PhoneInput, { CountryData } from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import "../styles/RegistrationStyle.css";
import {
  validateEmail,
  validateZipCode,
  validateRequiredFields,
  validateOrganizationName,
  validateAddress,
  validateStateOrCity,
  validateName,
  validateLastName,
} from "./ValidationComponent";
import ".././.././../styles/CommonStyles.css";
import Select from "react-select";

const requiredFields = ["firstName", "lastName"];

const SecondStep: React.FC = () => {
  const { setCurrentStep, userData, setUserData, currentStep } =
    useContext(multiStepContext)!;
  const [errors, setErrors] = useState<any>({});
  const navigate = useNavigate();

  const handleNext = () => {
    const checkError = validateRequiredFields(requiredFields, userData);

    if (userData["firstName"]) {
      const orgNameError = validateName(userData["firstName"]);
      if (orgNameError) checkError["firstName"] = orgNameError;
    }

    if (userData["lastName"]) {
      const orgNameError = validateLastName(userData["lastName"]);
      if (orgNameError) checkError["lastName"] = orgNameError;
    }
    setErrors(checkError);

    if (Object.keys(checkError).length === 0) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleChange = (selectedOption: any) => {
    handleInputChange(
      "admissionYear",
      selectedOption ? selectedOption.value : "",
    );
  };

  const handleQualificationChange = (selectedOption: any) => {
    handleInputChange(
      "educationalQualification",
      selectedOption ? selectedOption.value : "",
    );
  };

  const handleInputChange = (field: string, value: string) => {
    // Prevent consecutive spaces and spaces at the beginning/end
    let sanitizedValue = value.replace(/\s{2,}/g, " ").trimStart();

    if (["city", "state", "country"].includes(field)) {
      sanitizedValue = sanitizedValue
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
    }

    setUserData({ ...userData, [field]: sanitizedValue });
  };

  const handleInputBlur = (field: string, value: string) => {
    // Trim the value for the specific field when the input loses focus
    setUserData({ ...userData, [field]: value.trim() });
  };

  const currentYear = new Date().getFullYear(); // Get the current year
  const startYear = 2017;

  const options = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => {
      const year = currentYear - index;
      return { value: year.toString(), label: year.toString() };
    },
  );

  const qualificationOptions = [
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "UG", label: "UG" },
    { value: "PG", label: "PG" },
  ];

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      border: `1px solid ${state.isFocused ? "#e5e7eb" : "#e5e7eb"}`,
      backgroundColor: "white", // Light background for the control
      borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb", // Blue border when focused
      boxShadow: state.isFocused ? "0 0 0 1px #e5e7eb" : "none", // Optional shadow when focused
      "&:hover": {
        borderColor: "#e5e7eb", // Blue border on hover
      },
      borderRadius: "8px",
      padding: "5px",
      height: "50px",
      fontFamily: "Poppins",
      fontSize: "14px",
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "#fff",
      borderRadius: "8px",
      marginTop: "0",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(177, 177, 181, 0.084)" // Light background when selected
        : state.isFocused
          ? "rgba(177, 177, 181, 0.084)" // Light background when focused
          : "#fff", // Default background
      color: state.isSelected || state.isFocused ? "#000" : "#000", // Black text color
      padding: "10px",
      fontFamily: "Poppins",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: "rgba(145, 145, 147, 0.084)", // Slightly different background on hover
        color: "#000", // Black text color on hover
      },
      "&:active": {
        backgroundColor: "rgba(177, 177, 181, 0.084)", // Background when clicked
        color: "#000", // Black text color when clicked
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the vertical separator (|) near the select icon
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      padding: "0", // Adjusts the padding around the dropdown icon to remove spacing
    }),
  };

  return (
    <div className="FormStep" style={{ paddingBottom: "20px" }}>
       <div style={{ height: "50vh", overflowY: "auto" }}>
      <div className="form-input">
        <Row className="custom-row">
          <Col className="custom-col">
            <Form.Label htmlFor="firstName">First Name *</Form.Label>
            <Form.Control
              className="rounded-input"
              type="text"
              id="firstName"
              value={userData["firstName"]}
              onChange={(e) => handleInputChange("firstName", e.target.value)}
              onBlur={(e) => handleInputBlur("firstName", e.target.value)}
              maxLength={256}
            />
            {errors.firstName && (
              <div className="error-message">{errors.firstName}</div>
            )}
          </Col>

          <Col className="custom-col">
            <Form.Label htmlFor="lastName">Last Name *</Form.Label>
            <Form.Control
              className="rounded-input"
              type="text"
              id="lastName"
              value={userData["lastName"]}
              onChange={(e) => handleInputChange("lastName", e.target.value)}
              onBlur={(e) => handleInputBlur("lastName", e.target.value)}
              minLength={3}
              maxLength={256}
            />
            {errors.lastName && (
              <div className="error-message">{errors.lastName}</div>
            )}
          </Col>
        </Row>
      </div>

      <div className="form-input">
        <Row className="custom-row">
          <Col className="custom-col">
            <Form.Label htmlFor="rollNo">Student Roll No.</Form.Label>
            <Form.Control
              className="rounded-input"
              type="email"
              id="rollNo"
              value={userData["rollNo"]}
              onChange={(e) => handleInputChange("rollNo", e.target.value)}
            />
            {errors.rollNo && (
              <div className="error-message">{errors.rollNo}</div>
            )}
          </Col>

          <Col className="custom-col">
            <Form.Label htmlFor="admissionYear">Admission Year</Form.Label>
            <Select
              options={options}
              value={options.find(
                (option) => option.value === userData["admissionYear"],
              )}
              onChange={handleChange}
              placeholder=" "
              styles={customStyles}
            />
            {errors.admissionYear && (
              <div className="error-message">{errors.admissionYear}</div>
            )}
          </Col>
        </Row>
      </div>

      <div className="form-input">
        <Row className="custom-row">
          <Col className="custom-col">
            <Form.Label htmlFor="educationalQualification">
              Education Qualification
            </Form.Label>
            <Select
              options={qualificationOptions}
              value={options.find(
                (option) =>
                  option.value === userData["educationalQualification"],
              )}
              onChange={handleQualificationChange}
              placeholder=" "
              styles={customStyles}
            />
            {errors.educationQualification && (
              <div className="error-message">
                {errors.educationQualification}
              </div>
            )}
          </Col>
          <Col className="custom-col">
            <Form.Label htmlFor="course">Course</Form.Label>
            <Form.Control
              className="rounded-input"
              type="text"
              id="course"
              value={userData["course"]}
              onChange={(e) => handleInputChange("course", e.target.value)}
            />
            {errors.course && (
              <div className="error-message">{errors.course}</div>
            )}
          </Col>
        </Row>
      </div>

      <div className="form-input">
        <Form.Label htmlFor="instituteName">Institute Name</Form.Label>
        <Form.Control
          className="rounded-input"
          type="text"
          id="instituteName"
          value={userData["instituteName"]}
          onChange={(e) => handleInputChange("instituteName", e.target.value)}
        />
        {errors.instituteName && (
          <div className="error-message">{errors.instituteName}</div>
        )}
      </div>

      <center>
        <div className="form-button">
          <button className="buttonForForm" onClick={handleNext}  style={{
    backgroundColor: userData["firstName"]&& userData["lastName"]
      ? "#ffc85d"
      : "#eaeff9",
    cursor: userData["firstName"]&& userData["lastName"]
      ? "pointer"
      : "not-allowed",
  }}>
            Next
          </button>
        </div>

        <p className="login-styling">
          Already have an Account?{" "}
          <span className="login-link" style={{color:"#2563eb"}} onClick={() => navigate("/")}>
            Login
          </span>
        </p>
      </center>
    </div></div>
  );
};

export default SecondStep;
